export default function tableOfContentsSmoothScroll() {
  const tocInner = window.document.querySelector(".Blog-sidebar-toc-inner")
  const links = tocInner.querySelectorAll("ul li a")
  links.forEach(link => {
    link.addEventListener("click", clickHandler)
  })

  function clickHandler(e) {
    e.preventDefault()
    const href = this.getAttribute("href")
    const elementToScrollTo = document.querySelector(href)
    elementToScrollTo.scrollIntoView({ behavior: "smooth" })
  }
}
